exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{background-color:#000e27;overflow:hidden}#wrap{background-color:#000e27;background-image:url(" + require("./images/texture.png") + ");transition:background-color 1s ease-in}#main-container,#wrap{position:absolute;width:100%;height:100%}#main-container{overflow:auto}#bg_magic_circle{position:absolute;top:0;left:0;right:0;bottom:0;opacity:.05;background:url(" + require("./images/bg-img.png") + ") 50% fixed no-repeat;transition:opacity 1s ease-in}@media (max-width:770px){body{height:100%;overflow:scroll;-webkit-overflow-scrolling:touch}#wrap{height:100%;background-color:#000e27;background-image:url(" + require("./images/texture.png") + ");transition:background-color 1s ease-in}#main-container,#wrap{position:static;width:100%}#main-container{height:auto;overflow:auto}}.bp-field-error{padding:0;color:red;list-style:none}#error{padding:0 186px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./examples/app.less
 ** module id = 46
 ** module chunks = 0
 **/